/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelRichtext64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelRichtext64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g>
            <path
              d="M21 24C21 24.5523 20.5523 25 20 25C19.4477 25 19 24.5523 19 24C19 23.4477 19.4477 23 20 23C20.5523 23 21 23.4477 21 24Z"
              fill="currentColor"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16 21.5C16 20.6716 16.6716 20 17.5 20H27.5C28.3284 20 29 20.6716 29 21.5V31.5C29 32.3284 28.3284 33 27.5 33H17.5C16.6716 33 16 32.3284 16 31.5V21.5ZM17.5 21C17.2239 21 17 21.2239 17 21.5V31.2929L21.7929 26.5C22.1834 26.1095 22.8166 26.1095 23.2071 26.5L28 31.2929V21.5C28 21.2239 27.7761 21 27.5 21H17.5ZM27.2929 32L22.5 27.2071L17.7071 32H27.2929Z"
              fill="currentColor"
            />
            <path d="M48 33L35 33V32H48V33Z" fill="currentColor" />
            <path d="M16 39L48 39V38L16 38V39Z" fill="currentColor" />
            <path d="M16 45H32V44H16V45Z" fill="currentColor" />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelRichtext64Icon.tags = [
  'richtext',
  'editor',
  'text',
  'image',
  'document',
];

AddPanelRichtext64Icon.category = '64x64 (Add panel)';

AddPanelRichtext64Icon.iconSize = 64;
